"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import {
  commonFormFields,
  commonValidationRules,
} from "@/libs/builder/common/formFields";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const formTextInputInputs = [
  ...commonFormFields,
  ...commonValidationRules,
  {
    name: "inputType",
    type: "string",
    defaultValue: "text",
    enum: ["text", "email", "phone"],
  },
  {
    name: "validationErrorMessage",
    type: "string",
  },
  {
    name: "minLength",
    type: "number",
  },
  {
    name: "maxLength",
    type: "number",
  },
  {
    name: "matchingFieldId",
    type: "string",
  },
  {
    name: "mathchingFieldErrorMessage",
    type: "string",
  },
  {
    name: "mode",
    type: "string",
    defaultValue: "standard",
    enum: ["standard", "editable"],
  },
  {
    name: "isLocked",
    type: "boolean",
    defaultValue: false,
  },
] as const satisfies Inputs;

export const FormTextInputComponent: RegisteredComponent = {
  name: "FormTextInput",
  component: dynamic(async () =>
    withValidation(
      formTextInputInputs,
      (await import("./FormTextInput")).FormTextInput,
      "FormTextInput"
    )
  ),
  inputs: formTextInputInputs,
};
